import { TableLoader } from '@client/new/components/TableShared/TableLoader';

export const Loader = () => (
  <div
    className="flex justify-center items-center"
    style={{ minWidth: '200px', marginTop: '120px' }}
  >
    <TableLoader rows={3} height={106} />
  </div>
);
